import React from 'react'
import classes from './ToggleButton.module.css'
function ToggleButton() {
  return <div className={classes.button}>Toggle</div>
}

export default ToggleButton
